const style = getComputedStyle(document.body)

const CONF = {
    APP_URL: process.env.MIX_APP_URL,
    API_URL: process.env.MIX_APP_URL + '/api',
    APP_LOGIN_URL: '/',
    APP_DEFAULT_URL: '/dashboard',
    APP_NAME: process.env.MIX_APP_NAME,
    PRIMARY_COLOR: style.getPropertyValue('--primary'),
    PRIMARY_COLOR_07: `${style.getPropertyValue('--primary')}70`,
    DF_MOMENTS: 'DD MMM, YYYY',
    DB_MOMENTS: 'YYYY-MM-DD',
    DB_MOMENTS_TIME: 'YYYY-MM-DD HH:mm:00',
    MOMENT_TIME_HUMAN: 'h:mmA',
    MOMENT_DATETIME_HUMAN: 'D MMM, YYYY h:mmA',
    ROLLBACK_TOKEN_JS: process.env.MIX_ROLLBACK_TOKEN_JS,
    ROLLBACK_ENV: process.env.MIX_ROLLBACK_ENV
}

export default CONF